export function optionHasPersistedContent(option = {}) {
  return (Array.isArray(option?.items) ? option.items : []).some(
    (item) => item && typeof item === "object",
  );
}

export function resolveMealOptionDeleteRequest(option, pendingDeleteOptionId = null) {
  const optionId = String(option?.id ?? "").trim();

  if (!optionId) {
    return {
      action: "noop",
      nextPendingDeleteOptionId: null,
    };
  }

  if (!optionHasPersistedContent(option) || pendingDeleteOptionId === optionId) {
    return {
      action: "delete",
      nextPendingDeleteOptionId: null,
    };
  }

  return {
    action: "confirm",
    nextPendingDeleteOptionId: optionId,
  };
}

export function clearPendingDeleteOptionOnSelection(
  pendingDeleteOptionId,
  nextSelectedOptionId,
) {
  const pendingId = String(pendingDeleteOptionId ?? "").trim();
  const selectedId = String(nextSelectedOptionId ?? "").trim();

  if (!pendingId || !selectedId || pendingId === selectedId) {
    return pendingId || null;
  }

  return null;
}

export function clearPendingDeleteOptionIfMissing(
  pendingDeleteOptionId,
  options = [],
) {
  const pendingId = String(pendingDeleteOptionId ?? "").trim();
  if (!pendingId) {
    return null;
  }

  const stillExists = (Array.isArray(options) ? options : []).some(
    (option) => String(option?.id ?? "").trim() === pendingId,
  );

  return stillExists ? pendingId : null;
}

export function shouldDismissPendingDeleteFromPointerTarget(target, containerNode) {
  if (!target || !containerNode || typeof containerNode?.contains !== "function") {
    return true;
  }

  return !containerNode.contains(target);
}
